export { default } from './ReviewsTextSlide';
